import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { IconButton } from 'src/components/Atoms/IconButton';
import Button from '@mui/material/Button';
import useTranslations from 'src/hooks/useTranslations';
interface CloseProps {
  icon?: boolean;
  variant?: 'text' | 'outlined' | 'contained' | 'icon';
  onClick: () => void;
  onClose?: () => void;
}
const CloseButton = styled(IconButton)(({
  theme
}) => ({
  position: 'absolute',
  top: theme.sizes.spacing['04'],
  right: theme.sizes.spacing['04'],
  zIndex: 1000,
  color: theme.colors.text.primary,
  backgroundColor: 'none',
  '&:hover': {
    color: theme.colors.text.primary
  }
}));
const Close: React.FC<CloseProps> = t0 => {
  const $ = _c(12);
  const {
    icon,
    variant,
    onClose,
    onClick
  } = t0;
  const {
    t
  } = useTranslations();
  let t1;
  if ($[0] !== onClick || $[1] !== onClose) {
    t1 = () => {
      if (onClose) {
        onClose();
      }
      if (onClick) {
        onClick();
      }
    };
    $[0] = onClick;
    $[1] = onClose;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  if (!onClick) {
    console.warn("no onClick function provided to Close component");
    return null;
  }
  if (icon || variant === "icon") {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <CloseIcon />;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== handleClick) {
      t3 = <CloseButton onClick={handleClick} aria-label="Close">{t2}</CloseButton>;
      $[4] = handleClick;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t2;
  if ($[6] !== t) {
    t2 = t("common.close");
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== handleClick || $[9] !== t2 || $[10] !== variant) {
    t3 = <Button variant={variant} onClick={handleClick}>{t2}</Button>;
    $[8] = handleClick;
    $[9] = t2;
    $[10] = variant;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default Close;
export type { CloseProps };